import crud from "./crud";
import crud_service from "@/services/crud";
import { isNone } from "@/functions";
const path = "prod_availability_months";
const struct = {
  month: null,
  value: "",
  producer_id: null,
};
const generic = crud(path, struct);

const state = {
  ...generic.state,
  loading: false,
};

const getters = {
  ...generic.getters,
};

const mutations = {
  ...generic.mutations,
};

const actions = {
  ...generic.actions,


  refresh({ commit }, payload) {
    return crud_service.fetch(`${path}/refresh`, payload)
      .then(() => {
      })
      .catch((error) => {
        console.error("Error in refresh action:", error);
        throw error;
      });
  },

  getHistory({ commit }, { start, end } = {}) {
    // Month availability history between two months (ISO strings)
    var payload = {};
    if (!isNone(start)) payload["start"] = start;
    if (!isNone(end)) payload["end"] = end;
    return new Promise((resolve) => {
      crud_service
        .fetch(`${path}/history`, payload)
        .then((items) => {
          commit("setItems", items);
          resolve(items);
        })
        .catch(() => {});
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
